// removed by extract-text-webpack-plugin
module.exports = {"caption":"_29qck","captionText":"kDqar","captionCredit":"G8hlm"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Helpers/Bildtext/Bildtext.scss
 ** module id = 431
 ** module chunks = 0
 **/